// extracted by mini-css-extract-plugin
module.exports = {"logoOnhover":"Footer_logoOnhover__lcMDC"};